/**
 * Typed wrapper for the agent's passcode-rotation endpoint:
 *
 *   PUT /api/access-key  body { newKey }  → { ok: true }
 *
 * The request itself must carry the CURRENT passcode (injected by
 * `agentFetch`), so only an already-unlocked device can rotate it.
 */
import { agentFetch } from './agent-fetch';
import { loadPublicEnv } from './env';

export type Result<T> = { ok: true; value: T } | { ok: false; error: string };

function baseUrl(): string {
  return loadPublicEnv().agentDevUrl.replace(/\/+$/, '');
}

export const accessKeyApi = {
  async change(newKey: string): Promise<Result<{ ok: boolean }>> {
    try {
      const res = await agentFetch(`${baseUrl()}/api/access-key`, {
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ newKey }),
      });
      if (!res.ok) {
        return { ok: false, error: `HTTP ${res.status} ${res.statusText}` };
      }
      const value = (await res.json()) as { ok: boolean };
      return { ok: true, value };
    } catch (err) {
      return { ok: false, error: err instanceof Error ? err.message : String(err) };
    }
  },
};
